module.exports = __webpack_public_path__ + "static/contacto-6dff16898d801d0eec74f50cceaf461b.jpg";